import { Button, Grid } from '@mui/material';
import React from 'react';
import { useTranslation } from 'services/localization';

interface Props {
	onCancel: () => void;
	onSave: () => void;
	savingDisabled: boolean;
}

export const EditHeaderBar = ({ onCancel, onSave, savingDisabled }: Props) => {
	const { t } = useTranslation();
	return (
		<Grid container justifyContent="space-between">
			<Grid item>
				<Button onClick={onCancel}>{t('common:actions.cancel')}</Button>
			</Grid>
			<Grid item>
				<Button disabled={savingDisabled} variant="contained" color="primary" onClick={onSave}>
					{t('common:actions.save', 'Save')}
				</Button>
			</Grid>
		</Grid>
	);
};
